// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateVpButton_container__2yiPY","rounded":"CreateVpButton_rounded__2Mqwd","buttonico_vp":"CreateVpButton_buttonico_vp__1iAtj","title":"CreateVpButton_title__3ajmj"};